import useCollapse from './use-collapse'
import useEventListener from '~hooks/use-event-listener-deprecated'
import { TransitionEvent, useRef } from 'react'

export type Props = {
  isOpen: boolean
  handleClose?: () => void
  style?: React.CSSProperties
  transition?: string
  children: React.ReactNode
}

export function Collapse({
  isOpen = false,
  handleClose,
  style: initialStyle,
  transition = 'height 250ms cubic-bezier(0.4, 0, 0.2, 1)',
  ...rest
}: Props) {
  const content = useRef(null)

  const { setIsExpandedStyle, setIsCollapsedStyle, style } = useCollapse({
    isOpen,
    content,
  })

  const handleKeyDown = (event: KeyboardEvent) => {
    const isEscapeKey = event.key === 'Escape' || event.key === 'Esc'
    if (isEscapeKey) {
      handleClose?.()
    }
  }

  useEventListener('keydown', handleKeyDown)

  const onTransitionEnd = (e: TransitionEvent) => {
    if (e.target === content.current && e.propertyName === 'height') {
      if (isOpen) {
        setIsExpandedStyle()
      } else {
        setIsCollapsedStyle()
      }
    }
  }

  const styles = {
    willChange: 'height',
    transition,
    ...initialStyle,
    ...style,
  } as React.CSSProperties

  return (
    <div
      ref={content}
      style={styles}
      onTransitionEnd={onTransitionEnd}
      {...rest}
    />
  )
}
